<mat-card class="example-card">
    <mat-card-header>
        <!-- <mat-card-title>
            <span>{{ sceenshotDataSource?.added_date}}</span>
            <span (click)="confirm(sceenshotDataSource?.id)">
                <mat-icon class="color-red">delete</mat-icon>
            </span>
        </mat-card-title> -->
        <div class="title">
            <div class="left-title">
                <span class="forDate">{{ sceenshotDataSource?.added_date}}</span>
            </div>
            <div class="right-title">
                <span class="forDeleteAction" (click)="confirm(sceenshotDataSource?.id)">
                    <mat-icon class="color-red">delete</mat-icon>
                </span>
            </div>
        </div>
    </mat-card-header>
    <img mat-card-image src="{{SCREENSHOT_PATH}}{{sceenshotDataSource?.screenshot_name}}" alt="{{sceenshotDataSource?.screenshot_name}}">
</mat-card>